import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

new Vue({
  router : router,
  render: h => h(App),
  watch: {
    '$route' (to, from) {
      gtag('config', 'UA-119336067-1', {'page_path' : to.path});
      //console.log(typeof to.path);
      //console.log(to.path);
    }
  }
}).$mount('#app')
